<template lang="pug">
.totalizadores-volume
    .totalizadores-linha
        .totalizadores-saldo
            span {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.volumeTotals.balance') }}
            h2 {{ formatNumber(saldo) }} t
        .totalizadores-volume-disponivel
            span {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.volumeTotals.availableVolume') }}
            h2 {{ formatNumber(volumeDisponivel) }} t
        .totalizadores-volume-comprometido
            span {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.volumeTotals.committedVolume') }}
            h2 {{ formatNumber(volumeComprometido) }} t
</template>

<script>
import EventBus from '@/utils/eventBus';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import formatters from '@/utils/formatters';

export default {
    name: 'TotalVolumeDefault',
    data() {
        return {
            dadosSaldo: [],
            saldo: 0,
            volumeComprometido: 0,
            volumeDisponivel: 0,
            intervalId: null
        };
    },
    mounted() {
        this.getVolumeTotalizer();
        this.intervalId = setInterval(this.getVolumeTotalizer, 60000);
    },
    destroyed() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    },
    methods: {
        emitValues() {
            this.dadosSaldo = [this.saldo, this.volumeDisponivel, this.volumeComprometido];
            EventBus.$emit('totalizer-updated', this.dadosSaldo);
        },
        async getVolumeTotalizer() {
            await RelatorioRastreabilidadeService.findVolumeTotalizer()
            .then(res => {
                this.saldo = res.data.totalVolumeContracts;
                this.volumeComprometido = res.data.totalVolumeReport;
                this.volumeDisponivel = res.data.totalVolumeAvaliable;
                this.emitValues();
            })
            .catch(error => {
                if (error) {
                    this.$notify.error(this.$t('relatorio_rastreabilidade.messages.traceabilityReport.volumeTotals.error'));
                }
            });
        },
        formatNumber(number) {
            return formatters.formatNumber(number);
        }
    }
};
</script>
<style lang="scss" scoped>
.totalizadores-volume {
    margin-top: 15px;
}
.totalizadores-linha {
    width: 100%;
    display: flex;
}
.totalizadores-saldo {
    width: 33%;
    display: flex;
    justify-content: space-between;
    background-color: white;
    padding: 15px;
    border-radius: 6px;
    margin-right: 10px;
}
.totalizadores-volume-disponivel {
    width: 33%;
    display: flex;
    justify-content: space-between;
    background-color: white;
    padding: 15px;
    border-radius: 6px;
    margin-right: 10px;

    h2 {
        color: var(--secondary-two);
    }
}
.totalizadores-volume-comprometido {
    width: 33%;
    display: flex;
    justify-content: space-between;
    background-color: white;
    padding: 15px;
    border-radius: 6px;

    h2 {
        color: var(--error-500);
    }
}
</style>
